import { Phone, Play } from 'lucide-react';
import Button from 'components/crm/ui/Button';
import DrawnGlyph from 'components/crm/ui/emptyState/DrawnGlyph';
import useText from 'hooks/useText';
import { firstNameOf, splitLines } from 'pages/prospection/callListItems';

/**
 * The right column while calls remain and no call sheet is open, framed by its
 * own dashed border. With a queue and no line brought forward, it offers to
 * launch the session; otherwise it offers to call the highlighted line, or the
 * first one to call.
 */
const IdlePanel = ({ pending, highlightedLine, onLaunch, onCall }) => {
  const { text, plural } = useText('prospection');
  const { queue } = splitLines(pending);
  const launching = queue.length > 0 && !highlightedLine;
  const target = highlightedLine || pending[0];

  return (
    <section className="flex h-full min-w-0 flex-1 flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-lineStrong bg-white px-10 text-center">
      <span
        data-testid="idle-glyph"
        className="relative mb-2 flex size-24 items-center justify-center rounded-full bg-surfaceMuted text-faint"
      >
        <DrawnGlyph name="hourglass" />
      </span>
      <p className="font-title text-lg font-semibold text-ink">
        {text('idle.title')}
      </p>
      <p className="max-w-[400px] text-sm leading-5 text-muted">
        {launching ? plural('idle.launch', queue.length) : text('idle.call')}
      </p>
      {launching ? (
        <Button className="mt-2" icon={Play} onClick={onLaunch}>
          {text('idle.launch')}
        </Button>
      ) : (
        target && (
          <Button className="mt-2" icon={Phone} onClick={() => onCall(target)}>
            {text('idle.callButton', {
              name: firstNameOf(
                target.company?.contactName,
                target.company?.name,
              ),
            })}
          </Button>
        )
      )}
    </section>
  );
};

export default IdlePanel;
